import { render, staticRenderFns } from "./Afmetingen.vue?vue&type=template&id=bebdf24a"
import script from "./Afmetingen.vue?vue&type=script&lang=js"
export * from "./Afmetingen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports